
const LoadingComponent = ({isLoading, error}) => {
    return null;
};

export default LoadingComponent;